// D-0097: as telas de Detalhe voltam com history.goBack(). Para o painel reabrir na aba de onde
// o usuário saiu, ele guarda as abas na query da própria URL (history.replace) e as lê no estado
// inicial. Valor desconhecido ou ausente na URL cai no padrão.

export function abaDaUrl(search, chave, validas, padrao) {
    const valor = new URLSearchParams(search || '').get(chave);
    return validas.indexOf(valor) >= 0 ? valor : padrao;
}

// Query com as abas gravadas, preservando os outros parâmetros (idEvento, grupoTitulo…).
export function searchComAbas(search, abas) {
    const params = new URLSearchParams(search || '');
    Object.keys(abas).forEach((chave) => {
        if (abas[chave]) params.set(chave, abas[chave]); else params.delete(chave);
    });
    const texto = params.toString();
    return texto ? '?' + texto : '';
}

// Grava as abas na URL atual sem criar entrada no histórico (o Voltar do detalhe volta para cá).
export function gravarAbasNaUrl(history, abas) {
    const search = searchComAbas(history.location.search, abas);
    if (search === history.location.search) return;
    history.replace({ pathname: history.location.pathname, search, state: history.location.state });
}
